import { render, staticRenderFns } from "./RichInputEmojis.vue?vue&type=template&id=2e78250c&"
import script from "./RichInputEmojis.vue?vue&type=script&lang=js&"
export * from "./RichInputEmojis.vue?vue&type=script&lang=js&"
import style0 from "./RichInputEmojis.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports